module.exports = __webpack_public_path__ + "img/vcx.6ebc218f.jpg";